import Vue from 'vue'
import { objectTrim } from '@/utils'
import {
  RESET_SEARCH_PARAM,
  SET_SEARCH_PARAM,
  UPDATE_STATE_OBJ,
  UPDATE_NAMESPACE,
} from './mutation-types'

export default {
  namespaced: true,
  state: {
    namespace: 'outsourcing',
  },
  getters: {
    searchData: (state, getters, rootState) => {
      const searchParams = state[state.namespace] || {}
      const { pageSize, pageNum } = rootState.pagination
      return objectTrim({ ...searchParams, pageSize, pageNum }, false, true, true, true)
    },
  },
  mutations: {
    [UPDATE_STATE_OBJ]: (state, { namespace, params }) => {
      if (!namespace) return console.error('namespace is required')
      if (!state[namespace]) Vue.set(state, namespace, {})
      Object.entries(params).forEach(([key, value]) => {
        state[namespace][key] = value
      })
      state[namespace] = { ...state[namespace] }
    },
    [SET_SEARCH_PARAM]: (state, payload) => {
      const { key, value } = payload
      state[key] = value
    },
    [RESET_SEARCH_PARAM]: (state, namespace) => {
      state[namespace] = null
    },
    [UPDATE_NAMESPACE]: (state, namespace) => {
      state.namespace = namespace
    },
  },
  actions: {
    resetSearchParam({ commit }, namespace) {
      commit(RESET_SEARCH_PARAM, namespace)
    },
  },
}
